export const CLEAR_GIF_IMAGE =
  '/content/dam/delta-applications/header/clear.gif';
